import React, {useState, useEffect} from 'react'
import { Translation } from 'react-i18next';
import {BllinkLogger} from '../../common/utils/bllink_loggers';
import loginLogic from './loginLogic';
import './login.css';
import CacheData from "../../common/utils/cacheData";

function LoginTitle(){

    return (
        <Translation>{(t, {_}) =>
            <div className="container">
                <div className="row">
                    <div className="login-from col-md-12">
                        <h2 className="text-center">{t('login.login_building_title')}</h2>
                        <p>{t('login.reset_password_sub_title')}</p>
                    </div>
                </div>
            </div>
        }</Translation>
    )
}


function LoginOptions(){
    return (
        <Translation>{(t, {_}) =>
            <div className="row">
                <div className="login_from">
                    <div className="login_form_11 text-center">
                        {/*<div className="form-group">*/}
                        {/*    <label htmlFor="Email">{t('signup.email')} * </label>*/}
                        {/*    <input type="email" className="form-control" name="email"*/}
                        {/*           id="login-email" autoComplete="off" disabled={true}/>*/}
                        {/*</div>*/}
                        <div className="form-group">
                            <label htmlFor="Email">{t('login.new_password')} * </label>
                            <input type="password" className="form-control" name="password"
                                   id="login-password" autoComplete="off"/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="login-password">{t('login.new_password_again')} * </label>
                            <input type="password" className="form-control" name="password"
                                   id="login-password-validation" autoComplete="off"
                            />
                        </div>
                        <div className="row form-group col-12 col-md-11" hidden={true}>
                            <label id="login-error" className="error"/>
                        </div>

                        <div id="message">
                            <h3>{t('login.must_contain')}</h3>
                            <p id="letter" className="invalid">{t('login.small_letter')}</p>
                            <p id="capital" className="invalid">{t('login.capital_letter')}</p>
                            <p id="number" className="invalid">{t('login.number')}</p>
                            <p id="length" className="invalid">{t('login.8_digits')}</p>
                            <p id="passwords-are-the-same" className="invalid">{t('login.same_passwords')}</p>
                        </div>

                    </div>

                    <div className="login_form_12">
                        <div id="reset-text-section" className="form-group">
                            <p>{t('login.reset_password_sub_explain')}</p>
                        </div>
                    </div>

                </div>
            </div>
        }</Translation>
    )
}

function LoginActions(){


    return (
        <Translation>{(t, {_}) =>
            <div className="login_last_sec">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group login_right">
                            <input type="submit" name="login-account" className="bllink-button" id="reset-password"
                                   value={t('login.reset_password')}/>
                        </div>
                    </div>
                </div>
            </div>
        }</Translation>
    )
}


export default function LoginChangePassword() {

    const [state] = useState({});

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        BllinkLogger.info(`LoginChangePassword initiated state `, state);
        loginLogic.bindPasswordTyping();
        const userCred = CacheData.fetchCache('userResetPassword', {typeOfCache: sessionStorage});

        if (!userCred){
            alert('נא להתחבר מחדש לפני אתחול סיסמא');
            // window.location.href = `/${constants.pages.loginUrl}`;
        }else {
            loginLogic.bindResetInitialPassword(userCred);
        }
    });

    return (
        <div>
            <LoginTitle/>

            <section>
                <div className="container">
                    <div className="col-md-12">
                        <div className="login_detail">
                            <form>
                                <LoginOptions/>
                                <LoginActions/>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

